// extracted by mini-css-extract-plugin
export default {"root":"FamilyTariffList__root--2nGbk"};